module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner _clearboth hide-sm mt-0"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "banner__list"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1722f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 712
// module chunks = 1